<template>
  <div class="panel">
    <div class="panel-heading">
      <h3 class="panel-title text-center">
        Общая статистика изучения материала
      </h3>
    </div>
    <div class="panel-body">
      <div class="report-content">
        <span v-if="loading" class="error loading status_padding">
          <i class="fa fa-spinner fa-pulse" aria-hidden="true"></i>Загрузка
          данных...
        </span>

        <span v-else-if="error" class="error status_padding">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>Ошибка
          загрузки данных
        </span>

        <span v-else-if="isStatsEmpty">
          <p class="error">Нет данных для статистики</p>
        </span>
        <GChart
          v-else
          type="ColumnChart"
          :data="chartData"
          :options="chartOptions"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { GChart } from "vue-google-charts/legacy";

export default {
  name: "UserStatsAllDiagram",
  data() {
    return {
      loading: true,
      error: false,
      stats: [],
      chartOptions: {
        hAxis: {
          viewWindow: {
            min: [7, 30, 0],
            max: [17, 30, 0],
          },
        },
        legend: { position: "none" },
        width: "100%",
        height: 400,
      },
    };
  },
  computed: {
    chartData() {
      return [
        ["Статистика", "Количество людей", { role: "style" }],
        ...this.stats,
      ];
    },
    isDataEmpty() {
      return this.stats.length === 0;
    },
    isPointsEmpty() {
      return this.stats.every((point) => {
        return point[1] === 0;
      });
    },
    isStatsEmpty() {
      return this.isDataEmpty || this.isPointsEmpty;
    },
  },
  components: {
    GChart,
  },
  methods: {
    get_data() {
      axios
        .get("/widgets/UserStatsAll")
        .then((response) => {
          this.stats = response.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.error = true;
        });
    },
  },
  mounted() {
    this.get_data();
  },
};
</script>

<style scoped>
.error,
.loading {
  display: inline-block;
}
.error i,
.loading i {
  margin-right: 5px;
}

.error {
  font-weight: bold;
}
</style>
